import { create } from 'zustand';
import type { WSConnectionState } from '@/lib/ws';

export interface TelemetrySample {
  readonly fps: number;
  readonly frameTimeMs: number;
  readonly drawCalls: number;
  readonly wsLagMs: number;
  readonly eventsPerSec: number;
  /** Live WebSocket connection state — drives the STATE health readout. */
  readonly wsState: WSConnectionState;
}

interface TelemetryState extends TelemetrySample {
  setSample: (partial: Partial<TelemetrySample>) => void;
}

const ZERO: TelemetrySample = {
  fps: 0,
  frameTimeMs: 0,
  drawCalls: 0,
  wsLagMs: 0,
  eventsPerSec: 0,
  wsState: 'idle',
};

export const useTelemetryStore = create<TelemetryState>((set) => ({
  ...ZERO,
  setSample: (partial) => set((prev) => ({ ...prev, ...partial })),
}));
